module.exports = __webpack_public_path__ + "img/serviceState7.d401e4ea.svg";